(() => {
  const init = () => {
    const toast = document.querySelector('[data-retailer-toast]');
    if (!toast) return;

    const storageKey = toast.getAttribute('data-storage-key') || 'retailer-toast-dismissed';
    const delay = parseInt(toast.getAttribute('data-delay') || '0', 10) || 0;

    const canUseStorage = (() => {
      try {
        const testKey = '__hh_storage_test__';
        window.localStorage.setItem(testKey, '1');
        window.localStorage.removeItem(testKey);
        return true;
      } catch {
        return false;
      }
    })();

    const isDismissed = () => {
      if (!canUseStorage) return false;
      return window.localStorage.getItem(storageKey) === '1';
    };

    const dismiss = () => {
      if (canUseStorage) window.localStorage.setItem(storageKey, '1');

      toast.classList.remove('is-visible');
      window.setTimeout(() => {
        toast.hidden = true;
      }, 220);
    };

    if (isDismissed()) return;

    window.setTimeout(() => {
      if (isDismissed()) return;
      toast.hidden = false;
      // next frame for CSS transition
      window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    }, delay);

    const closeBtn = toast.querySelector('[data-retailer-toast-close]');
    closeBtn?.addEventListener('click', dismiss);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

